import { PopperBase } from './popper-base';
import { LineSelectedMemo } from "../model";
import { PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO } from 'apps/events';
import PopperJS from 'popper.js';
import TimeLag from 'utilities/timelag';

class SaveTasksMemo extends PopperBase {
  lag: TimeLag;
  init(){
    super.init();
    this.lag = new TimeLag(() => { this.focus() }, 500)
    this.watchPlannerData('selectedTasksMemo', (newVal: any, oldVal: any, objectPath: string) => { this.onSelectTasksMemo(newVal, oldVal, objectPath)});
  }
  onSelectTasksMemo(selectedMemo: LineSelectedMemo, oldVal, objectPath) {
    if(selectedMemo === null){
      this.hide();
    } else {
      this.show(selectedMemo)
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  show(selectedMemo: LineSelectedMemo){
    this.isShow = true;
    let popper = new PopperJS(
      selectedMemo.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
    this.lag.start();
  }
  focus(){
    let input:HTMLInputElement = <HTMLInputElement>this.querySelector('input[name="memo[value]"]');
    input.focus()
    input.select();
  }
  onClose(){
    let e = new CustomEvent(PLANNER_CLOSE_DIALOG_SAVE_TASKS_MEMO, {});
    document.dispatchEvent(e);
  }
}

let scope = 'orders.planner.dialog.save-tasks-memo';
riot.mixin(scope, SaveTasksMemo as riot.TagMixin);
